import RenamePlaylist from './RenamePlaylist';
import RenamePlaylistContext from './RenamePlaylistContext';

export default {
  Consumer: RenamePlaylistContext.Consumer,
  Provider: RenamePlaylist,
};
